<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

if(document.querySelector('.slide-block-video_yAnANJ')){
  document.querySelector('.slide-block-video_yAnANJ').onclick = () => {
    const currentUrl = window.location.origin + window.location.pathname; // Текущий URL без параметров и хэша
    const newUrl = currentUrl.replace(/\/$/, '') + '/collections/pushers'; // Добавляем `pages/pusher-combo`, избегая двойного `/`
    window.location.href = newUrl;
  };
}

if(document.querySelector('.slide-block-video_UK7kQd')){
  document.querySelector('.slide-block-video_UK7kQd').onclick = () => {
    const currentUrl = window.location.origin + window.location.pathname; // Текущий URL без параметров и хэша
    const newUrl = currentUrl.replace(/\/$/, '') + '/collections/cosmetics'; // Добавляем `pages/pusher-combo`, избегая двойного `/`
    window.location.href = newUrl;
  };
}

if(document.querySelector('.slide-block-video_qwqBXU')){
  document.querySelector('.slide-block-video_qwqBXU').onclick = () => {
    const currentUrl = window.location.origin + window.location.pathname; // Текущий URL без параметров и хэша
    const newUrl = currentUrl.replace(/\/$/, '') + '/collections/gummy-pusher-yellow'; // Добавляем `pages/pusher-combo`, избегая двойного `/`
    window.location.href = newUrl;
  };
}